
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1081.012 1135.329"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 23","d":"M537.939 1135.33a23.537 23.537 0 01-7.993-1.4l-312.553-113.889c-.292-.117-.642-.233-.934-.35a24.261 24.261 0 01-4.668-2.567 23.514 23.514 0 01-4.143-3.851c-.292-.292-.525-.642-.817-.992L4.784 747.746A23.465 23.465 0 010 733.568V394.06a24.035 24.035 0 011.342-6.768 25.393 25.393 0 012.159-4.376 15.913 15.913 0 011.225-1.75l203.623-269.319a23.328 23.328 0 0111.319-8.11L529.945 1.11a1.081 1.081 0 01.409-.117h.234a25.009 25.009 0 016.768-.992 22.1 22.1 0 015.485.7h.117c.525.117.992.292 1.517.408l326.264 104.2a23.381 23.381 0 0111.844 8.577l193.879 269.2a22.978 22.978 0 014.551 13.478v.583l-1.575 341.492a23.039 23.039 0 01-4.609 13.828L877.622 1017.01c-.175.234-.35.467-.583.759a27.06 27.06 0 01-4.376 4.2 21.8 21.8 0 01-4.843 2.684c-.467.175-.933.35-1.458.525l-320.78 109.043a28.81 28.81 0 01-7.643 1.109zm.233-48.076zm495.988-658.012zM224.686 958.721L46.617 427.375zm795.531-574.054L560.81 55.077zM61.554 383.15l452.58-327.84z","fill":"#fff"}})])
          )
        }
      }
    